import { selectRequestingChangePlan } from '../../../../../store/workspace/selectors';
import { requestChangePlanThunk } from '../../../../../store/workspace/thunks';
import { setContactSalesModal } from '../../../../../store/workspace/slice';
import { selectProfile } from '../../../../../store/workspace/selectors';
import TextArea from '../../../../../components/TextArea';
import { useDispatch } from '../../../../../store/store';
import { useSelector } from '../../../../../store/store';
import { LayerIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import { useState } from 'react'

export default function ContactSales() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');
    const isLoading = useSelector(selectRequestingChangePlan);

    const confirmFunc = () => {
        const body = {
            message,
            action: 'sales',
            email: profile?.email,
            subject: 'Change Plan',
            company: profile?.companyName,
            name: `${profile?.firstName} ${profile?.lastName}`,
        };

        dispatch(requestChangePlanThunk(body));
    };

    return (
        <Modal
            size='md'
            icon={<LayerIcon />}
            title='Contact sales'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setContactSalesModal(false))}
        >
            <span className={styles.description}>
                We’re here to help! Reach out to us with any questions or feedback.
            </span>
            <Input value={subject} onChange={setSubject} type='text' label='Subject' />
            <TextArea value={message} onChange={setMessage} label='Message' />
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setContactSalesModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    loading={isLoading}
                    onClick={confirmFunc}
                    className={styles.actions_btn}
                    disabled={!message || !subject}
                />
            </div>
        </Modal>
    )
}
